import { render } from "./attom-desc.vue?vue&type=template&id=5fede298"
import script from "./attom-desc.vue?vue&type=script&lang=js"
export * from "./attom-desc.vue?vue&type=script&lang=js"

import "./attom-desc.vue?vue&type=style&index=0&id=5fede298&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/attom-desc.vue'],['render',render],['__file',"attom-desc.vue"]])

export default __exports__